import { gql } from "gql";

export const GET_ONLY_OFFICE_EDIT_FILE_SETTINGS = gql(/* GraphQL */ `
  query GetOnlyOfficeEditFileSettings($fileId: String!) {
    getOnlyOfficeEditFileSettings(fileId: $fileId) {
      ...OnlyOfficeFileSettings
    }
  }
`);

export const ONLYOFFICE_FILE_SETTINGS = gql(/* GraphQL */ `
  fragment OnlyOfficeFileSettings on OnlyOfficeFileEditSettingsDto {
    key
    editFileUrl
    onlyOfficeUrl
    saveCallbackUrl
  }
`);
